import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import PreSaleS1 from "../../components/preSaleS1";
import PreSaleS2 from "../../components/preSaleS2";
import PreSaleS3 from "../../components/preSaleS3";



const PreSalePage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Пресейл')}/>
            <PreSaleS1/>
            <PreSaleS2/>
            <PreSaleS3/>
        </section>
    );
};

export default PreSalePage;